import { render, staticRenderFns } from "./DeleteMessagesModal.vue?vue&type=template&id=0b77cbe3"
import script from "./DeleteMessagesModal.vue?vue&type=script&lang=js"
export * from "./DeleteMessagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b77cbe3')) {
      api.createRecord('0b77cbe3', component.options)
    } else {
      api.reload('0b77cbe3', component.options)
    }
    module.hot.accept("./DeleteMessagesModal.vue?vue&type=template&id=0b77cbe3", function () {
      api.rerender('0b77cbe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageCenter/DeleteMessagesModal.vue"
export default component.exports